export const DESKTOP_MQ: number = 1200;
export const MOBILE_MQ: number = 600;
export const TABLET_MQ: number = 900;
export const WIDTH = window.innerWidth;
export const IS_MOBILE = WIDTH < MOBILE_MQ;
